import React, { Component, useState, useEffect } from "react";
import "../index.css";
import { MDBRow, MDBCol } from "mdbreact";
import { NavLink, withRouter } from "react-router-dom";
import DashboardNavBar from "../Layout/DashboardNavBar";
import DashboardFooter from "../Layout/DashboardFooter";
import { firebase } from "../../../firebase/config";
import "react-phone-number-input/style.css";
import { FaChevronRight } from "react-icons/fa";

const Terms = ({ email, popUpVisible, setPopUpVisible, ref, seconds }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [uploadOptionsVisible, setUploadOptionsVisible] = useState(false);
  const [uploading, setUploading] = useState(true);
  const [youtubeLink, setYoutubeLink] = useState(null);
  const [uploadingArray, setUploadingArray] = useState([]);
  const [historyArray, setHistoryArray] = useState([]);
  const [processingArray, setProcessingArray] = useState([]);
  const [videoVisible, setVideoVisible] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(null);
  const [freeTrialUsed, setFreeTrialUsed] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  useEffect(() => {
    if (firebase.auth().currentUser) {
      const uid = firebase.auth().currentUser.uid;

      firebase
        .firestore()
        .collection("users")
        .doc(uid)
        .onSnapshot((doc) => {
          setFreeTrialUsed(doc.data().freeTrialUsed);
        });

      firebase
        .firestore()
        .collection("customers")
        .doc(uid)
        .collection("subscriptions")
        .where("status", "==", "active")
        .onSnapshot((querySnapshot) => {
          if (!querySnapshot.empty) {
            let initActive = [];
            querySnapshot.forEach((doc) => {
              console.log(doc.data());
              initActive.push(doc.data());
            });
            if (initActive.length > 0) {
              setSubscribed(true);
            }
          } else {
            setSubscribed(false);
          }
        });
      console.log(uid);
      firebase
        .firestore()
        .collection("users")
        .doc(uid)
        .collection("tasks")
        .onSnapshot((querySnapshot) => {
          if (!querySnapshot.empty) {
            let initArray = [];
            let processArray = [];
            let uploadArray = [];
            querySnapshot.forEach((doc) => {
              console.log(doc.data());
              if (doc.data().status === "Complete") {
                initArray.push(doc.data());
              } else if (
                doc.data().status !== "Error" &&
                doc.data().status !== "Complete" &&
                doc.data().status !== "Uploading"
              ) {
                setUploading(false);
                processArray.push(doc.data());
              } else if (doc.data().status === "Uploading") {
                setUploading(true);
                uploadArray.push(doc.data());
              }
            });

            console.log("The init array is,", initArray);
            setHistoryArray(initArray);
            setProcessingArray(processArray);

            setUploadingArray(uploadArray);
          }
        });
    }
  }, [firebase.auth().currentUser]);

  useEffect(() => {
    setPopUpVisible(false);
  }, []);

  useEffect(() => {
    console.log("Uploading array is", uploadingArray);
  }, [uploadingArray]);

  useEffect(() => {
    setYoutubeLink("");
  }, [modalVisible]);

  return (
    <>
      <div
        style={{
          overflowX: "hidden",
          height: "100vh",
        }}
      >
        <div
          style={{
            overflowX: "hidden",
            paddingBottom: 0,
            color: "rgb(242, 241, 243)",
            backgroundColor: "#121114",
            height: "100vh",
          }}
        >
          <MDBCol
            style={{
              width: "105vw",
              overflowX: "hidden",
              paddingBottom: 0,
              paddingBottom: 95,
            }}
            size="12"
          >
            <MDBRow style={{ marginTop: 0 }}>
              <DashboardNavBar
                popUpVisible={popUpVisible}
                setPopUpVisible={setPopUpVisible}
                email={email}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                seconds={seconds}
                ref={ref}
              />
            </MDBRow>
            <MDBCol
              className="d-flex justify-content-center"
              style={{ marginTop: 150 }}
              size="12"
            >
              <MDBRow style={{ width: 1340, paddingLeft: 20 }}>
                <MDBCol size="12">
                  <p style={{ fontSize: 49, fontFamily: "PPBold" }}>
                    Term of Service
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Last Updated: 27/10/2023
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Introduction
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    Welcome to Cloneshort, an AI-powered platform designed to
                    create TikTok videos tailored to your brand. By using our
                    services, you agree to comply with these Terms of Service.
                    Please read them carefully.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Acceptance of Terms
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    By accessing or using the Cloneshort platform, you
                    acknowledge that you have read, understood, and agree to be
                    bound by these Terms of Service.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Registration and Account Security
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    1. To use Cloneshort, you must register for an account.
                  </p>
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    2. You are responsible for maintaining the confidentiality
                    of your login credentials.
                  </p>
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    3. You must provide accurate and complete information during
                    the registration process.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Service Plans and Payments
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    1. Cloneshort offers various plans with different features
                    and pricing.
                  </p>
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    2. Payments are non-refundable, except as required by law or
                    as stated in our refund policy.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Service Plans and Payments
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    1. Cloneshort's AI algorithms will generate content based on
                    the information you provide.
                  </p>
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    2. You retain all rights to the content generated for you,
                    but grant Cloneshort a license to use it for service
                    improvement.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Limitation of Liability
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    Cloneshort shall not be liable for any indirect, incidental,
                    or consequential damages, including, but not limited to,
                    loss of profits, data, or brand reputation.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Ethical AI Usage
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    We are committed to using AI in an ethical and transparent
                    manner. Our algorithms are designed to be responsible and
                    compliant with relevant regulations.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Termination
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    Cloneshort reserves the right to terminate your account and
                    access to the services for violations of these terms or any
                    illegal activities.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Changes to Terms
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    Cloneshort may update these Terms of Service at any time.
                    The updated terms will be posted on our website and
                    effective immediately upon posting.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Governing Law
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    These Terms of Service are governed by the laws of the
                    United Kingdom, without regard to its conflict of law
                    principles.
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 25,
                      fontFamily: "PPBold",
                      marginTop: 20,
                    }}
                  >
                    Contact Information
                  </p>
                </MDBCol>
                <MDBCol size="12">
                  <p
                    style={{
                      fontSize: 18,
                      fontFamily: "PPMedium",
                      marginTop: 0,
                      width: "85%",
                    }}
                  >
                    For any questions about these Terms of Service, please
                    contact us at help@cloneshort.com
                  </p>
                </MDBCol>
              </MDBRow>
            </MDBCol>

            {firebase.auth().currentUser ? null : (
              <>
                {/* <Explainer />
                {/* <Process /> */}
                {/* <Steps />
                <Pricing />
                <div style={{ marginTop: 50 }}></div>
                <Questions />  */}
              </>
            )}
          </MDBCol>
          <div
            style={{
              backgroundColor: "#30312c",
              position: "absolute",
              bottom: 20,
              right: 30,
              height: 46,
              width: 320,
              borderRadius: 8,
              color: "white",
              fontFamily: "PPMedium",
              textAlign: "center",
              cursor: "pointer",
              opacity: 1,
              zIndex: 9000,
            }}
            className="d-flex justify-content-center"
          >
            <p style={{ marginTop: 13, fontSize: 15 }}>
              Have questions? Join our Discord{" "}
              <FaChevronRight
                style={{ fontSize: 12, marginLeft: 6, marginTop: -2.67 }}
                className="d-inline"
              />
            </p>
          </div>
          <DashboardFooter />
        </div>
      </div>
    </>
  );
};

export default withRouter(Terms);
